module.exports = __webpack_public_path__ + "673c4801d3ccbc74dcf46a92f30bed07.png";